export default {
  cancelled: {
    id: 'sav_platform_cancelled',
    defaultMessage: 'Canceled',
  },
  cancelDate: {
    id: 'sav_platform_cancel_date_new',
    defaultMessage:
      'Canceled on {cancelDate, date, short} at {cancelDate, time, short}',
  },
  delivered: {
    id: 'sav_platform_delivered',
    defaultMessage: 'Delivered',
  },
  downloadDeliveryForm: {
    id: 'sav_platform_download_delivery_form',
    defaultMessage: 'Download the shipping label',
  },
  notTracked: {
    id: 'sav_platform_not_tracked',
    defaultMessage: 'Parcel not tracked',
  },
  orderDate: {
    id: 'sav_platform_order_date_new',
    defaultMessage:
      'Ordered on {orderDate, date, short} at {orderDate, time, short}',
  },
  paid: {
    id: 'sav_platform_paid',
    defaultMessage: 'Paid',
  },
  refunded: {
    id: 'sav_platform_refunded',
    defaultMessage: 'Refunded',
  },
  shipped: {
    id: 'sav_platform_shipped',
    defaultMessage: 'Shipped',
  },
  stateUnknown: {
    id: 'sav_platform_state_unknown',
    defaultMessage: 'Unknown',
  },
  title: {
    id: 'sav_platform_history_new',
    defaultMessage: 'Order N°{order}',
  },
  track: {
    id: 'sav_platform_track_parcel',
    defaultMessage: 'Track package',
  },
  validated: {
    id: 'sav_platform_validated',
    defaultMessage: 'Validated',
  },
  errorDescription: {
    id: 'bo_sellers_customer_care_request_details_order_history_description_error',
    defaultMessage: 'Couldn’t load order details',
  },
}
